/**
 * design/gdd/game-concept.md §10 Risk #3 — "the KayKit look is generic,"
 * mitigated with "a recoloured atlas from the Source .blend." The dungeon
 * pack already ships 6 hand-authored recolors
 * (`frontend/public/assets/dungeon-pack/textures/palette-swaps/`, see that
 * folder's README) that were never wired to anything — this is that wiring,
 * one palette per stratum so each floor reads as visually distinct instead
 * of the same corridor recolored only by lighting.
 *
 * Chosen for narrative progression, not just "3 different palettes":
 * earthy/damp (Cellars) -> stark bone-white (Ossuary, echoing the Bone
 * Warden) -> gilded treasure (Vaults, the deepest and richest floor).
 */
/** Keyed by Run.stratum's depth convention (1=Cellars, 2=Ossuary, 3=Vaults) — see backend/src/game/shared/stratum.ts. */
const STRATUM_PALETTE: Record<number, string> = {
  1: 'alt_texture_3_SepiaA',
  2: 'alt_texture_2_BlackAndWhite',
  3: 'alt_texture_1_Golden',
};

export function paletteForStratum(stratumDepth: number): string | undefined {
  return STRATUM_PALETTE[stratumDepth];
}
